(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cookie-preferences"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', async event => {
    const button = event.target.closest('[data-cookie-preferences]');
    if (!button || button.disabled) return;
    const message = button.parentElement.querySelector('[data-cookie-error]');
    message.hidden = true;
    button.disabled = true;
    try {
      if (!window.privacyBanner?.showPreferences) throw new Error('banner_unavailable');
      await window.privacyBanner.showPreferences();
    } catch {
      message.textContent = button.dataset.error;
      message.hidden = false;
    } finally {
      button.disabled = false;
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-gallery"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('misa-gallery')) customElements.define('misa-gallery',class extends HTMLElement{
    connectedCallback(){
      this.controller=new AbortController();
      const rail=this.querySelector('.product-gallery__thumbnails'),selected=this.querySelector('[aria-pressed="true"]');
      if(rail&&selected)requestAnimationFrame(()=>{if(this.isConnected)rail.scrollLeft=selected.offsetLeft-rail.offsetLeft-(rail.clientWidth-selected.clientWidth)/2;});
      this.addEventListener('click',event=>{
        const thumbnail=event.target.closest('[data-gallery-select]');
        if(thumbnail){
          this.querySelectorAll('[data-gallery-panel]').forEach(panel=>{panel.hidden=panel.dataset.mediaId!==thumbnail.dataset.gallerySelect;if(panel.hidden)panel.querySelectorAll('video').forEach(video=>video.pause());});
          this.querySelectorAll('[data-gallery-select]').forEach(button=>button.setAttribute('aria-pressed',String(button===thumbnail)));
        }
        const zoom=event.target.closest('[data-gallery-zoom]');
        if(zoom&&!event.metaKey&&!event.ctrlKey){event.preventDefault();this.zoomTrigger=zoom;const img=zoom.querySelector('img').cloneNode();img.removeAttribute('srcset');img.removeAttribute('sizes');img.src=zoom.href;this.querySelector('[data-zoom-content]').replaceChildren(img);this.querySelector('dialog').showModal();}
        if(event.target.closest('[data-close-zoom]'))this.querySelector('dialog').close();
      },{signal:this.controller.signal});
      this.querySelector('dialog').addEventListener('close',()=>this.zoomTrigger?.focus(),{signal:this.controller.signal});
    }
    disconnectedCallback(){this.controller?.abort();}
  });
  } catch(e) { console.error(e); }
})();

})();
